import { AvailableProvider, FormData, CreateProviderPayload } from "../types";
import type { Provider } from "../../../../DealerAcquirersTable/types";

export interface CreateProviderObjectParams {
  id: string;
  selectedProvider: AvailableProvider;
  formData: FormData;
  payload: CreateProviderPayload;
  dealerId: string;
  createdAt?: string;
  useCredentialsFallback?: boolean;
}

export function createProviderObject({
  id,
  selectedProvider,
  formData,
  payload,
  dealerId,
  createdAt,
  useCredentialsFallback = false,
}: CreateProviderObjectParams): Provider {
  const credentials = useCredentialsFallback
    ? payload.credentials || {
        type:
          selectedProvider.credentials?.type ||
          selectedProvider?.schema?.properties?.credentials?.properties?.type
            ?.const ||
          "",
      }
    : payload.credentials;

  return {
    id,
    name: selectedProvider.name,
    code: selectedProvider.code || "",
    type: selectedProvider.type || "Gateway",
    priority: formData.priority || 0,
    methods: payload.methods || ["Credit"],
    credentials,
    acquirer: {
      merchantId: payload.acquirer.merchantId || dealerId,
      brands: payload.acquirer.brands || [],
      creditBrands: [],
      debitBrands: [],
    },
    state: payload.state,
    merchant: { id: dealerId },
    createdAt: createdAt || new Date().toISOString(),
    modifiedAt: new Date().toISOString(),
  };
}
